"use client";

import { c as _c } from "react/compiler-runtime";
import { RegistreringViewControlProvider } from "@/app/(registrering)/state/contextState";
import { EditView } from "./EditView";
import { SubmitView } from "./SubmitView";
export function ViewControl() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RegistreringViewControlProvider EditView={EditView} SubmitView={SubmitView} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}